import React from 'react';
import classNames from 'classnames';
import { Button } from 'bootstrap';
import { Map } from 'immutable';
import PDFExportFormActions from 'flux/actions/cuesheet.printable/PDFExportFormActions';
import ModalActions from 'flux/actions/ModalActions';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import UIRegions from 'shared/constants/UIRegions';
import Dropdown from 'shared/components/menus/dropDown';

export default React.createClass({
  displayName: 'PDFPresetOptions',

  render() {
    const { pdfPresets, activePresetId, transientPresetChange } = this.props;

    if (!pdfPresets) return null;

    const activePreset =
      activePresetId && pdfPresets.has(activePresetId)
        ? pdfPresets.get(activePresetId)
        : null;

    let items = pdfPresets.map((preset) => {
      return Map({
        type: 'link',
        content: (
          <div data-testid={`preset-${preset.get('_id')}`}>
            {preset.get('title')}
          </div>
        ),
        onClick: () => PDFExportFormActions.setPresetInState(preset.get('_id')),
      });
    });

    items = items.set(
      'newPreset',
      Map({
        type: 'link',
        content: (
          <div>
            <Icon name="plus" /> Create new preset
          </div>
        ),
        onClick: () => ModalActions.show(UIRegions.CreatePDFPresetModal),
        itemClass: 'create-new-preset',
      }),
    );

    const config = Map({
      noCaret: false,
      icon: null,
      content: activePreset ? (
        <span data-testid={`activePreset-${activePreset.get('_id')}`}>
          {activePreset.get('title')}
        </span>
      ) : (
        'Select a preset'
      ),
      items,
    });

    const isUpdateablePreset =
      activePreset &&
      activePreset.get('_id') !== 'generic' &&
      activePreset.get('_id') !== 'personal';

    const buttonClasses = classNames('btn-save', 'preset-btn', {
      inactive: !transientPresetChange,
    });

    return (
      <div>
        <h2 className="pdf-side-panel-title">Presets</h2>
        <div className="pdf-option-wrapper">
          <div className="pdf-option-title">Choose or create:</div>
          <Dropdown className="generic-dropdown-menu" config={config} />
          {isUpdateablePreset && (
            <Button
              className={buttonClasses}
              onClick={() => {
                if (transientPresetChange)
                  PDFExportFormActions.updatePreset(activePreset.get('_id'));
              }}
            >
              Save
            </Button>
          )}
        </div>
      </div>
    );
  },
});
